// tslint:disable:no-invalid-template-strings

export const MOBILE_RECOMMENDATIONS_SEARCH_GA = {
  event: 'AutoEvent',
  eventCategory: 'Äri avaleht - Personaalsed soovitused - Mobiiltelefonide soovitused',
  eventAction: 'Otsing',
  eventLabel: '${searchKey}',
};

export const VOLTE_RECOMMENDATIONS_SEARCH_GA = {
  event: 'AutoEvent',
  eventCategory: 'Äri avaleht - Personaalsed soovitused - VoLTE soovitused',
  eventAction: 'Otsing',
  eventLabel: '${searchKey}',
};

export const DOWNLOAD_EXCEL_GA = {
  event: 'AutoEvent',
  eventCategory: 'Äri avaleht - Personaalsed soovitused - Mobiiltelefonide soovitused',
  eventAction: 'Header',
  eventLabel: 'Lae excel',
};

export const MOBILE_RECOMMENDATIONS_CLICK_GA = {
  event: 'AutoEvent',
  eventCategory: 'Äri avaleht - Personaalsed soovitused - Mobiiltelefonide soovitused',
  eventAction: 'Vaatan lähemalt',
  eventLabel: 'Hetkel:${currentDeviceName},Vanus:${deviceAge},Soovitus:${recommendedDeviceName}',
};

export const VOLTE_RECOMMENDATIONS_CLICK_GA = {
  event: 'AutoEvent',
  eventCategory: 'Äri avaleht - Personaalsed soovitused - VoLTE aktiveerimine',
  eventAction: 'Vaatan lähemalt',
  eventLabel: 'Hetkel:${deviceName},Soovitus:VoLTE aktiveerimine',
};

// tslint:enable:no-invalid-template-strings
